import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex, IBoxProps, IFlexProps, ITheme } from '../../../ui';
import { getGradientBackground } from '../../shared/styles';
import themed from '../../../ui/themer/themed';

const StyledFlex = styled(Flex)<IFlexProps, ITheme>`
	border: ${themed(({ border }) => border.default)};
	margin: 10px 0;
	padding: 10px;
	height: 150px;
`;

const StyledBox = styled(Box)<IBoxProps, ITheme>`
	border: ${themed(({ border }) => border.highlight)};
	padding: 10px;
	margin: 10px;
`;

const StyledFlexDark = styled(Flex)<IFlexProps>`
	${getGradientBackground('green-blue')}
	margin: 10px 0;
	padding: 40px;

	h2 {
		margin-bottom: 0;
		color: #fff;
	}
`;

export const FlexBoxes = () => (
	<>
		<h2 id="flexbox">Flexbox</h2>

		<StyledFlex justifyContent="center" alignItems="center">
			<StyledBox width="100px">hello</StyledBox>
			<StyledBox width={['200px', { mobile: '100px', desktopXL: '400px' }]}>
				world
			</StyledBox>
		</StyledFlex>

		<StyledFlex inline>
			<StyledBox width="100px">hello</StyledBox>
			<StyledBox width={['200px', { mobile: '100px', desktopXL: '400px' }]}>
				world
			</StyledBox>
		</StyledFlex>

		<StyledFlexDark justifyContent="space-between" alignItems="center">
			<h2>hello</h2>
			<> </>
			<h2>world</h2>
		</StyledFlexDark>
	</>
);
